import { render, staticRenderFns } from "./ResumationFileInput.vue?vue&type=template&id=5a7ac5a0&"
import script from "./ResumationFileInput.vue?vue&type=script&lang=js&"
export * from "./ResumationFileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports